
  
  // Orders Data
  const orders = {
    columns: [        
      {
        Header: "ID",
        accessor: "id"      
      },
      {
        Header: "MODE",
        accessor: "deliveryType"      
      },
      {
        Header: "ORIGIN",
        accessor: "origin"      
      },
      {
        Header: "PICK UP DATE",
        accessor: "pickUpDate"      
      },
      {
        Header: "DESTINATION",
        accessor: "destination"      
      },
      {
        Header: "DROP OFF DATE",
        accessor: "dropOffDate"      
      },
      {
        Header: "CLASS",
        accessor: "class"      
      },
      {
        Header: "SUBMITTED",
        accessor: "submitted"      
      },
      {
        Header: "STATUS",
        accessor: "status"      
      },
      {
        Header: "",
        accessor: "actions",
        sortable: false,
        filterable: false
      }
  
    ],  
    dataLoaded: false
  };
  
  export const initState = {
    orders
  }
  
  export default (state = initState, action) => {
    switch (action.type) { 
      case 'SET_ORDERS_LIST':
        console.log('SET_ORDERS_LIST')     
        return {
          ...state,
          orders: {
            ...state.orders,
            dataRows: action.dataRows,
            dataLoaded: true
          }
        }
        case 'SET_PENDING_ORDERS_LIST':
          console.log('SET_PENDING_ORDERS_LIST')     
          return {
            ...state,
            pendingOrders: {
              ...state.orders,
              dataRows: action.dataRows,
              dataLoaded: true
            }
          };      
          case 'SET_DISPATCHED_ORDERS_LIST':
            console.log('SET_DISPATCHED_ORDERS_LIST')     
            return {
              ...state,
              dispatchedOrders: {
                ...state.orders,
                dataRows: action.dataRows,
                dataLoaded: true
              }
            };      
            case 'SET_CONFIRMED_ORDERS_LIST':
              console.log('SET_CONFIRMED_ORDERS_LIST')     
              return {
                ...state,
                confirmedOrders: {
                  ...state.orders,
                  dataRows: action.dataRows,
                  dataLoaded: true
                }
              };      
  
  
      default:
        return state
    }
  }



// WEBPACK FOOTER //
// ./src/store/reducers/ordersReducer.jsx